import { render, staticRenderFns } from "./ingresosDeCaja.vue?vue&type=template&id=5c7585fd&"
import script from "./ingresosDeCaja.vue?vue&type=script&lang=js&"
export * from "./ingresosDeCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports